import { ReactNode } from 'react'
import { TimeTrackingContext, TimeTrackingContextType } from './TimeTrackingContextTypes'

interface TimeTrackingProviderProps {
  children: ReactNode
  timeTracking: TimeTrackingContextType
}

export function TimeTrackingProvider({ children, timeTracking }: TimeTrackingProviderProps) {
  return (
    <TimeTrackingContext.Provider value={timeTracking}>
      {children}
    </TimeTrackingContext.Provider>
  )
} 